import { useAnalysisStore } from '@modules/analysis/store/analysisStore';
import { DASHBOARD_TV_MODE_POLL_DURATION } from '@modules/dashboard/constants';
import { useFetchQuantifyReport } from '@modules/quantify/hooks';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { isValidQuery } from '@modules/quantify/utils';
import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useUpdateEffect } from 'react-use';
import { useShouldShowDashboardQuantifyAsTable } from '../useShouldShowDashboardQuantifyAsTable';

export const useFetchQuantifyReportDataForGlobalFilters = () => {
  const [searchParams] = useSearchParams();

  const [isLoading, setIsLoading] = useState(false);

  const analysisID = useAnalysisStore(({ id }) => id);
  const query = useQuantifyStore(({ query }) => query);
  const dashboardFilters = useQuantifyStore(
    ({ visual }) => visual.dashboardFilters,
  );

  const shouldShowQuantifyTable =
    useShouldShowDashboardQuantifyAsTable(analysisID);

  const shouldFetchTableData = shouldShowQuantifyTable;

  const fetchQuantifyReportData = useFetchQuantifyReport({
    fetchPolicy: 'cache-and-network',
    shouldFetchChartData: !shouldFetchTableData,
    shouldFetchTableData,
  });

  const fetchQuantifyReportDataAsync = useCallback(async () => {
    setIsLoading(true);
    await fetchQuantifyReportData();
    setIsLoading(false);
  }, [fetchQuantifyReportData]);

  useEffect(() => {
    const isDashboardInTVMode = searchParams.has('tv');
    if (!isDashboardInTVMode) {
      return;
    }

    const intervalID = setInterval(() => {
      fetchQuantifyReportDataAsync();
    }, DASHBOARD_TV_MODE_POLL_DURATION);

    return () => clearInterval(intervalID);
  }, [fetchQuantifyReportData, fetchQuantifyReportDataAsync, searchParams]);

  useUpdateEffect(() => {
    const isValidQueryState = isValidQuery(query);
    if (isValidQueryState) {
      fetchQuantifyReportDataAsync();
    }
  }, [
    dashboardFilters?.whereClause,
    dashboardFilters?.duration,
    dashboardFilters?.aggregatePeriod,
    shouldShowQuantifyTable,
  ]);

  return isLoading;
};
